import React from "react";
import styles from "../../../styles/screens/AmritjalProductDetail/AmritjalSpray/PerfumeShowcase.module.css";
import hand from "../../../assets/amritjal_hp/Bottleinhand.png";
import { useNavigate } from "react-router-dom";
// import rosehand from "../../../assets/amritjal_hp/amritjal_rose_hand.png";

const PerfumeShowcase = ({ productId }) => {
  const navigate = useNavigate()

  const handleOrderNowClick = () => {
    navigate(`/dharmikx/checkout/${productId}`)
  }
  return (
    <div className={styles.perfumeBanner}>
      <div className={styles.bannerContainer}>
        <div className={styles.bannerLeft}>
          <img
            src={hand}
            alt="Amrit Jal Spray Perfume"
            className={styles.bottleImage}
          />
        </div>
        <div className={styles.bannerRight}>
          <h1 className={styles.bannerTitle}>
            {productId === "amritjal-spray" ? (
              "Own a Piece of"
            ) : (
              <>
                Perfume with zero alcohol
              </>
            )}
            <br />
            {productId === "amritjal-spray" ? (
              <span style={{ color: "#FF8E4C" }}>Mahakumbh’25</span>
            ) : null}
          </h1>
          <div className={styles.bannerDetails}>
            {productId === "amritjal-spray" ? (
              <>
                <p className={styles.bannerSubtitle}>
                  <span className={styles.divider}>
                    100% Pure | First time in India | Limited Edition{" "}
                  </span>
                </p>
                <p className={styles.bannerDescription}>
                  <span className={styles.divider}>
                    Direct from MahaKumbh 2025{" "}
                  </span>
                </p>{" "}
              </>
            ) : (
              <>
                <p className={styles.bannerSubtitle}>
                  <span className={styles.divider}>
                    First time in India | 0% Alcohol
                  </span>
                </p>
                <p className={styles.bannerDescription}>
                  <span className={styles.divider}>
                    Crafted from sacred waters of
                    Mahakumbh 2025.{" "}
                  </span>
                </p>
              </>
            )}
          </div>
          <button className={styles.orderButton} onClick={handleOrderNowClick}>ORDER NOW</button>
        </div>
      </div>
    </div>
  );
};

export default PerfumeShowcase;
